export const getUserCountry = async () => {
  const response = await fetch('/api/getCountry');
  const data = await response.json();
  return data.country;
};
